
export default function shadowsOnScroll(element) {

    const box = document.querySelector(element);
    const debug = false;
    let inProgress = false;

    if (!box) {
        return;
    }

    function shadowedBox() {
        if (inProgress) {
            return;
        }

        if (debug) {
            document.getElementById('scrollPosition').innerText = (box.scrollHeight - box.scrollTop - box.clientHeight) +  " " + box.scrollTop;
        }

        inProgress = true;

        if (box.scrollHeight > box.clientHeight) {
            box.classList.add("scrollbarred");
            box.classList.remove("no-scrollbarred");
        } else {
            box.classList.add("no-scrollbarred");
            box.classList.remove("scrollbarred");
        }

        if (box.clientHeight < box.scrollHeight && box.scrollTop > 1) {
            box.classList.add("shadow-top");
        } else {
            box.classList.remove("shadow-top");
        }

        if (box.scrollHeight - box.scrollTop - box.clientHeight < 1) {
            box.classList.remove("shadow-bottom");
        } else {
            box.classList.add("shadow-bottom");
        }

        inProgress = false;
    }

    shadowedBox();

    const debouncedShadowedBox = window.debounce(shadowedBox, 200);

    window.addEventListener("resize", debouncedShadowedBox);

    box.addEventListener("scroll", shadowedBox);

    const resizeObserver = new ResizeObserver(shadowedBox);
    resizeObserver.observe(box);
    if (box.children.length > 0) {
        for (let i = 0; i < box.children.length; i++) {
            resizeObserver.observe(box.children[i]);
        }
    }
}